import * as yup from 'yup';
import { z } from 'zod';

const PASSWORD_MIN_CHARS = 8;
const PASSWORD_MAX_CHARS = 99;

// Password validation
// https://stackoverflow.com/a/58767981
// https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html

export const passwordValidationSchema = yup
  .string()
  .min(PASSWORD_MIN_CHARS, `Must be more than ${PASSWORD_MIN_CHARS - 1} characters`)
  .max(PASSWORD_MAX_CHARS, `Must be less than ${PASSWORD_MAX_CHARS - 1} characters`)
  .matches(/(?=.*[a-z])/, { message: 'Lowercase characters required' })
  .matches(/(?=.*[A-Z])/, { message: 'Uppercase characters required' })
  .matches(/(?=.*[0-9])/, { message: 'Numbers required' })
  .matches(/(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-])/, {
    message: 'Special characters required',
  })
  .matches(/\S+/, 'Whitespace characters are not allowed');

export const passwordValidationZodSchema = z
  .string()
  .min(PASSWORD_MIN_CHARS, `Must be ${PASSWORD_MIN_CHARS} characters or more`)
  .max(PASSWORD_MAX_CHARS, `Must be ${PASSWORD_MAX_CHARS} characters or less`)
  .regex(/(?=.*[a-z])/, 'Lowercase characters required')
  .regex(/(?=.*[A-Z])/, 'Uppercase characters required')
  .regex(/(?=.*[0-9])/, 'Numbers required')
  .regex(/(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-])/, 'Special characters required')
  .regex(/\S+/, 'Whitespace characters are not allowed');
